import {useState, useEffect, Fragment, useCallback, useRef} from "react";
import {useQuery} from "react-query";
// import axios from "axios";

import AudioPlayer, {RHAP_UI} from "../react-h1-audio-player/index";
import "../react-h1-audio-player/styles.css";
import {ReactComponent as PauseIcon} from "../../assets/svgs/pause.svg";
import {ReactComponent as PlayIcon} from "../../assets/svgs/play.svg";
import {ReactComponent as SkipNextIcon} from "../../assets/svgs/skip-next.svg";
import {ReactComponent as SkipPreviousIcon} from "../../assets/svgs/skip-previous.svg";
import {ReactComponent as ForwardIcon} from "../../assets/svgs/forward.svg";
import {ReactComponent as RewindIcon} from "../../assets/svgs/backward.svg";
import {ReactComponent as ErrorIcon} from "../../assets/svgs/error.svg";
import {ReactComponent as DownloadIcon} from "../../assets/svgs/download.svg";

import styles from "./Player.module.scss";
// import 'react-h5-audio-player/lib/styles.less' Use LESS
// import 'react-h5-audio-player/src/styles.scss' Use SASS

import PlayerSongData from "./PlayerSongData/PlayerSongData";
import TogglePlayerPageButton from "./TogglePlayerPageButton/TogglePlayerPageButton";
import Spinner from "../UI/Loading/Spinner";
import {getTextFromArr, getTitleFromArr} from "../../functions/getJsxFromArr";
import {toast} from "react-toastify";
// import  Icon  from "@mui/material";

import {fetcher, hasLoginError} from "../../functions/requestFetcher";

import PlayerSongDataStyles from "./PlayerSongData/PlayerSongData.module.scss";
import Like from "../UI/Icon/Icon";

const audioUrl = videoId =>
  `${window.__SOUNDREX_API_URL__}/api/v1/audio?id=${videoId}`;

function ErrorText({text}) {
  return (
    <p className="white position-center link-large player-error-text">{text}</p>
  );
}
const toastOptions = {
  theme: "dark",
};
function Player({
  showQueueButtons,
  token,
  song,
  previousPage,
  changePlayerState,
  isPlayerPageOpen,
  togglePlayerPage,
  currentSongIndex,
  changeCurrentSong,
  // setCurrentSongIndex,
  upNextSongs = [],
  changeToNextSongIndex,
  changeToPreviousSongIndex,
  setIsAudioServerCrashed,
  setToastPosition,

  addToFavouritesHandler,
  removeFromFavouritesHandler,

  logout,

  // library,
}) {
  const [isAudioReady, setIsAudioReady] = useState(false);
  const [audioError, setAudioError] = useState(false);

  const asVolume = window.localStorage.getItem("volume") || 0.65;

  const [volume, setVolume] = useState(asVolume);

  const [isLiked, setIsLiked] = useState(false);

  const videoId = song?.videoId;
  const playlistId = song?.playlistId;
  const audioSrc = audioUrl(videoId);
  const lastSavedVideoId = useRef(null);

  const getBestThumbnail = (thumbnails) => {
    if (!Array.isArray(thumbnails) || thumbnails.length === 0) return "";
    
    const urls = thumbnails.map(t => t?.url).filter(Boolean);
    if (urls.length === 0) return "";
    
    let bestUrl = urls[urls.length - 1];
    if (!bestUrl || typeof bestUrl !== 'string') return "";
    
    bestUrl = bestUrl.replace(/=w\d+-h\d+/g, '=w800-h800');
    bestUrl = bestUrl.replace(/=w\d+/g, '=w800');
    bestUrl = bestUrl.replace(/\/w\d+-h\d+/, '/w800-h800');
    
    return bestUrl;
  };

  useEffect(() => {
    if (!song || !videoId || !token) return;
    
    const timer = setTimeout(() => {
      if (!videoId || !token) return;
      
      let title = "";
      let artist = "";
      
      try {
        const songData = song || {};
        
        if (songData.title) {
          if (typeof songData.title === 'string') {
            title = songData.title;
          } else if (Array.isArray(songData.title)) {
            title = songData.title.map(t => t?.text || t?.name || '').filter(Boolean).join(' ');
          } else if (songData.title.text) {
            title = songData.title.text;
          }
        }
        
        if (songData.subtitle) {
          if (typeof songData.subtitle === 'string') {
            artist = songData.subtitle;
          } else if (Array.isArray(songData.subtitle)) {
            artist = songData.subtitle.map(s => s?.text || s?.name || '').filter(Boolean).join(' • ');
          } else if (songData.subtitle.text) {
            artist = songData.subtitle.text;
          } else if (songData.subtitle.name) {
            artist = songData.subtitle.name;
          }
        }
        
        if (!artist && songData.shortBylineText) {
          if (typeof songData.shortBylineText === 'string') {
            artist = songData.shortBylineText;
          } else if (Array.isArray(songData.shortBylineText)) {
            artist = songData.shortBylineText.map(s => s?.text || s?.name || '').filter(Boolean).join(' • ');
          } else if (songData.shortBylineText.text) {
            artist = songData.shortBylineText.text;
          }
        }
      } catch (e) {}
      
      if (!title || title.trim() === '') title = "Unknown";
      if (!artist || artist.trim() === '') artist = "Unknown Artist";
      
      const thumbnail = getBestThumbnail(song?.thumbnails || []);
      
      fetch(window.__SOUNDREX_API_URL__ + "/Kiritofy/history", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token,
        },
        body: JSON.stringify({
          videoId: videoId,
          title: title,
          artist: artist,
          thumbnail: thumbnail,
        }),
      }).catch(() => {});
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [videoId, song, token]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof setToastPosition === "function") {
        setToastPosition("top-center");
      }
    }, 100);
    
    return () => {
      clearTimeout(timer);
      if (typeof setToastPosition === "function") {
        setToastPosition("bottom-center");
      }
    };
  }, [setToastPosition]);

  const {
    data: isLikedData,
    error,
    isError,
    isSuccess,
  } = useQuery(
    ["Kiritofy", videoId],
    () => {
      return fetcher(
        {
          url: `${window.__SOUNDREX_API_URL__}/Kiritofy/is-liked`,
          method: "POST",
          headers: {
            authorization: "Bearer " + token,
          },
          data: {
            id: videoId,
          },
        },
        false,
        false,
        false,
        null,
        null
        // () => logout()
      );
    },
    {
      // staleTime: 300000, // 5min
    }
  );

  let LikeBtn = (
    <div className="flex-center">
      <Spinner />
    </div>
  );

  // if there is an error, immediately return it to Ui
  if (isError && error) {
    const hasLoginErr = hasLoginError(error);
    if (hasLoginErr) {
      logout();
    }
    LikeBtn = <span></span>;
  }
  const songTitle = song?.title?.length > 0 && getTitleFromArr(song?.title);
  const songThumbnail =
    (song?.thumbnails?.length > 0 && song?.thumbnails?.[0]?.url) ||
    `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

  const isLikedHandler = useCallback(
    () =>
      isLiked
        ? removeFromFavouritesHandler(
            videoId,
            () => setIsLiked("loading"),
            () => setIsLiked(false),
            () => setIsLiked(true)
          )
        : addToFavouritesHandler(
            {
              videoId,
              id: videoId,
              title: songTitle,
              thumbnail: songThumbnail,
            },
            () => setIsLiked("loading"),
            () => setIsLiked(true),
            () => setIsLiked(false)
          ),
    [
      isLiked,
      videoId,
      songTitle,
      songThumbnail,
      addToFavouritesHandler,
      removeFromFavouritesHandler,
    ]
  );

  useEffect(() => {
    if (isSuccess) {
      if (isLikedData) {
        // const alreadyLiked = library?.find(s => s._id === videoId);
        setIsLiked(isLikedData?.isLiked);
      }
    }
  }, [isSuccess, isLikedData, videoId]);

  if (isSuccess) {
    if (isLikedData) {
      LikeBtn =
        isLiked === "loading" ? (
          <Spinner />
        ) : (
          <Like
            liked={isLiked}
            onClick={isLikedHandler}
            svg={isLiked ? "heart" : "heart-outline"}
            alt="Like song"
            className={`${PlayerSongDataStyles["like-icon"]}`}
          />
        );
    } else {
      LikeBtn = <span></span>;
    }
  }

  const nonChangingIcons = {
    next: <SkipNextIcon title="next" />,
    previous: <SkipPreviousIcon title="previous" />,
    forward: <ForwardIcon title="forward" />,
    rewind: <RewindIcon title="rewind" />,
  };

  const [playerCustomIcons, setPlayerCustomIcons] = useState({
    play: <PlayIcon title="Play" />,
    pause: <PauseIcon title="Pause" />,
    ...nonChangingIcons,
  });

  useEffect(() => {
    if (audioError) {
      song["error"] = song.hasOwnProperty("error") ? song.error + 1 : 1;

      // toast.error(
      //   audioError?.message
      //     ? audioError.message
      //     : "ERROR: Unable to play audio track.",
      //   toastOptions
      // );

      setPlayerCustomIcons({
        play: <ErrorIcon title="Unable to play audio" />,
        pause: <ErrorIcon title="Unable to play audio" />,
        ...nonChangingIcons,
      });

      const totalErrors = upNextSongs.reduce((p, c) => {
        return p + c.error || 0;
      }, 0);

      const totalSongs = upNextSongs?.length;

      if (totalErrors / totalSongs >= 1) {
        setIsAudioServerCrashed(true);
      }
      return;
    }
    if (isAudioReady) {
      changePlayerState("playing");
      return setPlayerCustomIcons({
        play: <PlayIcon title="Play" />,
        pause: <PauseIcon title="Pause" />,
        ...nonChangingIcons,
      });
    }
    if (!isAudioReady && !audioError) {
      // changePlayerState("loading");

      setPlayerCustomIcons({
        play: (
          <Spinner
            title="Loading..."
            style={{
              color: "#909090",
              width: "min-content",
              height: "min-content",
              cursor: "progress",
            }}
          />
        ),
        pause: (
          <Spinner
            title="Loading..."
            style={{
              color: "#909090",
              width: "min-content",
              height: "min-content",
              cursor: "progress",
            }}
          />
        ),
        ...nonChangingIcons,
      });
    }
  }, [isAudioReady, audioError, setIsAudioServerCrashed, song, upNextSongs, changePlayerState]);

  const nextButtonHandler = () => {
    changeToNextSongIndex();
  };

  const previousButtonHandler = () => {
    changeToPreviousSongIndex();
  };

  useEffect(() => {
    const indexSong = upNextSongs.find(s => s?.index === currentSongIndex);
    if (indexSong != null) {
      changeCurrentSong(indexSong);
    } else {
      setIsAudioReady(false);
    }
  }, [currentSongIndex, changeCurrentSong, upNextSongs]);

  const currentSongPageUrl = `/play?id=${videoId}${`${
    playlistId && `${!videoId ? "?" : "&"}list=${playlistId}`
  }`}`;

  const title =
    (song?.title || song?.title?.length > 0) && getTextFromArr(song.title);

  return (
    <Fragment>
      <AudioPlayer
        volume={volume}
        showSkipControls={
          !Boolean(audioError) && Boolean(showQueueButtons)
        }
        showJumpControls={!Boolean(audioError)}
        showFilledVolume={!Boolean(audioError)}
        showDownloadProgress={!Boolean(audioError)}
        showFilledProgress={!Boolean(audioError)}
        customIcons={playerCustomIcons}
        onClickNext={() => {
          setTimeout(() => {
            nextButtonHandler();
          }, 1500);
        }}
        onClickPrevious={() => {
          setTimeout(() => {
            previousButtonHandler();
          }, 1500);
        }}
        onLoadStart={e => {
          if (asVolume) {
            setVolume(Number(asVolume));
          }
          setIsAudioReady(false);
          setAudioError(false);
          changePlayerState("loading");
        }}
        onLoadedMetaData={e => {
          changePlayerState("playing");
          setIsAudioReady(true);
        }}
        onLoadedData={e => {
          changePlayerState("playing");
          setIsAudioReady(true);
        }}
        onVolumeChange={e => {
          const curVolume = e.target.volume;
          window.localStorage.setItem("volume", curVolume);
          setVolume(curVolume);
        }}
        onError={e => {
          setIsAudioReady(false);

          // setAudioError(true);
          setAudioError(e.target.error);

          setTimeout(() => {
            nextButtonHandler();
          }, 2500);

          changePlayerState("error");
        }}
        onPlayError={e => {
        }}
        onEnded={e => nextButtonHandler()}
        onListen={e => {
          const currentTime = e.target.currentTime;
          window.dispatchEvent(new CustomEvent("audio-time-update", { detail: currentTime }));
        }}
        listenInterval={100}
        onPlay={e => {
          if (isAudioReady) changePlayerState("playing");
        }}
        onPlaying={e => {
          if (isAudioReady) changePlayerState("playing");
        }}
        onPause={e => {
        }}
        className={`music-player ${
          audioError ? `disable-all ${styles["error-overlay"]}` : ""
        }`}
        autoPlay
        src={audioSrc}
        customProgressBarSection={
          [RHAP_UI.PROGRESS_BAR]
        }
        customControlsSection={
          [
            RHAP_UI.MAIN_CONTROLS,
            RHAP_UI.CURRENT_TIME,
            <div className="rhap_time rhap_time-divider">/</div>,
            RHAP_UI.DURATION,
            <PlayerSongData
              LikeBtn={LikeBtn}
              song={song}
              videoId={videoId}
            />,
            <input type="checkbox" className="music-player-more-options" />,
            <a
              id="download-audio"
              href={
                title &&
                videoId &&
                `${window.__SOUNDREX_API_URL__}/api/v1/audio-download?id=${videoId}&title=${title
                  ?.replace(/[^a-zA-Z ]/g, "")
                  ?.replace(" ", "+")}`
              }
              target="_blank"
              download
              rel="noreferrer">
              <DownloadIcon />
            </a>,
            <div className="music-player-more-options-like-button">{LikeBtn}</div>,
            RHAP_UI.VOLUME_CONTROLS,
            <TogglePlayerPageButton
              isPlayerPageOpen={isPlayerPageOpen}
              togglePlayerPage={togglePlayerPage}
              previousPage={previousPage}
              url={currentSongPageUrl}
            />,
            audioError && (
              <ErrorText
                text={
                  audioError?.message
                    ? audioError.message
                    : "ERROR: Unable to play audio track."
                }
              />
            ),
          ]
        }
      />
    </Fragment>
  );
}

export default Player;

